<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/TYKZV7/tc-custom/9781467442978.jpg?1731806992128" alt="This image is the cover for the book The Story Luke Tells"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Story Luke Tells
      </h1>
      <p class="bookDescription body article font2">
        <p>Among New Testament writers, who is the best historian? Without a doubt, says Justo Gonzalez, it’s Luke. Concerned about the particulars of people and events, Luke also gives readers the big picture, positioning the stories of Jesus not just in the history of Israel but in the history of humankind. Luke uniquely tells us the grand story of salvation -- then and now.<br/><br/>Gonzalez skillfully highlights key themes in Luke’s storytelling, including his strong emphasis on God’s “great reversals,” his keen interest in shared meals and their intimate connection to worship and communion, and his passionate underscoring of both the saving work of Christ and the indwelling power of the Holy Spirit. Writing in a conversational style, Gonzalez draws readers into Luke’s story with fresh overviews and rich details, showing how Luke invites us to continue his gospel witness today.<br/><br/>Watch a 2014 interview with the author of this book here:<br/><br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Justo L. González
      </h2>
      
      <p class="authorDescription body article"><B>Justo L. Gonz&aacute;lez</B> is a retired United Methodist minister and professor of historical theology. His more than one hundred books include <I>The Story of Christianity, A History of Christian Thought, Teach Us to Pray, Knowing Our Faith</I>, and <I>A Brief History of Sunday</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6e8f2aae